import React from 'react';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import Styles from './SideDrawer.module.css';
import Backdrop from '../../UI/Backdrop/Backdrop';
import Aux from '../../../hoc/Aux/Aux';

const sideDrawer =  (props) => {

	let attachedClasses = [Styles.SideDrawer , Styles.Closed];
	if(props.open) {
attachedClasses = [Styles.SideDrawer, Styles.open];
   
	}
	return (
		<Aux>
    <Backdrop show={props.open} click={props.closed}/>
      <div className={attachedClasses.join(' ')} onClick={props.closed}>
      <div className={Styles.Logo}> 
       <Logo/>
     </div>
     <nav>
     <NavigationItems isAuthenticated={props.isAuth} />
     </nav>
   </div>
   </Aux>
)
}
export default sideDrawer


// WEBPACK FOOTER //
// ./src/components/Navigation/SideDrawer/SideDrawer.js